<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>{{ $t('messages.enterprise.transferringDocuments') }}</md-dialog-title>

      <md-dialog-content>
        <form>
          <div class="md-layout md-gutter" v-if="documentOriginUser">
            <div class="md-layout-item md-size-100 mb-1">
              <md-field>
                <label for="fromName">{{ $t('widgets.transferDocuments.from') }}</label>
                <md-input
                  md-dense
                  name="fromName"
                  :value="documentOriginUser.fullName()"
                  disabled="disabled"
                />
              </md-field>
            </div>
            <div class="md-layout-item md-size-100 mb-1">
              <md-field>
                <label for="toName">{{ $t('widgets.transferDocuments.to') }}</label>
                <md-select
                  md-dense
                  name="toName"
                  v-model="toUserId"
                  :disabled="typeof toUserId === 'string'"
                  @md-selected="fetchTransferUser"
                >
                  <md-option
                    v-for="user in transferrableUsers"
                    v-bind:key="user.id"
                    :value="user.id"
                  >
                    {{ user.fullName() }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100 mb-1" v-if="user.id">
              <p>{{
                $tc(
                  'widgets.transferDocuments.documentsToTransfer',
                  user.stats.documents
                )
              }}</p>
            </div>
          </div>
        </form>
      </md-dialog-content>

      <md-dialog-actions v-if="user.stats">
        <md-button
          @click="cancelDocumentTransfer"
        >{{ $t('widgets.transferDocuments.cancel') }}</md-button>
        <md-button
          @click="requestDocumentTransfer"
          class="md-raised md-primary"
          :disabled="user.stats.documents === 0"
        >{{ $t('widgets.transferDocuments.commit') }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="showConfirmation"
      md-title="Confirm irreversible document transfer?"
      @md-cancel="showConfirmation = false"
      @md-confirm="confirmDocumentTransfer"
    />
  </div>
</template>
<script type="ts">
import User from '@/datatypes/user';
import UserService from '@/services/user/user-service';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default {
  name: 'user-document-transfer',
  props: {
    fromUser: {
      type: User,
      required: true,
    },
    users: {
      type: Array[User],
      required: true,
    },
  },
  data: () => ({
    userService: new UserService(),
    toUserId: undefined,
    user: new User({}),
    showConfirmation: false,
  }),
  methods: {
    fetchTransferUser() {
      this.userService.show(this.fromUser.id).then((response) => {
        this.user = new User(camelcaseKeysDeep(response.data));
      });
    },
    cancelDocumentTransfer() {
      this.$emit('cancelDocumentTransfer', true);
    },
    requestDocumentTransfer() {
      this.showConfirmation = true;
    },
    confirmDocumentTransfer() {
      this.userService.transferDocuments(this.fromUser.id, this.toUserId).then(() => {
        this.showConfirmation = false;
        this.$emit('documentTransferRequested', true);
      }).catch(() => {
        this.$emit('statusMessage', 'Document transfer error.');
      });
    },
  },
  computed: {
    transferrableUsers: {
      get() {
        return this.users.filter((user) => (user.id !== this.fromUser.id));
      },
    },
    documentOriginUser: {
      get() {
        return this.users.find((user) => (user.id === this.fromUser.id));
      },
    },
    documentDestinationUser: {
      get() {
        return this.users.find((user) => (user.id === this.toUserId));
      },
    },
    showDialog: {
      get() {
        return typeof this.fromUser.id === 'string';
      },
    },
  },
};
</script>
